const getGameTokenIdByCozyGameId = cozyGameId => {
  switch (cozyGameId) {
    case 1:
      return 1;
    default:
      return 1;
  }
};
export default getGameTokenIdByCozyGameId